<template>
    <div id="menubutton" :class="{menubutton:true, menubuttonscroll:getmenuflag || (menubuttonscroll_flag && scrollflag)}" @click="changemenuflag">
        <img v-if="!getmenuflag && getwidth" class="pctext" src="https://p3.udn.com.tw/wish/images/common/button_people_menu_pc.svg" />
        <img v-if="!getmenuflag && !getwidth" src="https://p3.udn.com.tw/wish/images/common/button_people_menu_mob.svg" />
        <img v-if="getmenuflag" src="https://p3.udn.com.tw/wish/images/common/button_people_menu_back.svg" />
    </div>
</template>
  
<script>
    import {sendGaMethods} from '@/assets/js/utils/masterBuilder.js';
    import {selectSrcMethod_3} from "@/assets/js/utils/masterBuilder.js";
    export default {
        mixins: [selectSrcMethod_3, sendGaMethods],
        data() {
            return {
                menubuttonscroll_flag:false,
                offsetfory: 0,
                offsettemp: window.innerHeight,
                scrollflag: true,
            };
        },
        created () {
            window.addEventListener('scroll', this.onScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.onScroll);
        },
        mounted(){
        },
        computed:{
            getmenuflag(){
                return this.$store.state.menuflag;
            },
            getwidth(){
                if(navigator.userAgent.match(/iPhone/i) || window.innerWidth<768) return false;
                return true;
            }
        },
        watch: {
            offsetfory: {
                handler: function(newHeight, oldHeight) {
                    if(newHeight>oldHeight){
                        if(newHeight-this.offsettemp>=window.innerHeight*2) this.scrollflag=false;
                    }
                    else{
                        this.scrollflag=true;
                        this.offsettemp=Math.max(newHeight, window.innerHeight);
                    }
                    if(window.innerWidth>=960) this.scrollflag=true;
                }
            },
        },
        methods:{
            changemenuflag(){
                if(!this.$store.state.menuflag) this.sendGA({category: 'wisher bar', action: 'click', label: "click_wisher_bar"});
                this.$store.state.menuflag=!this.$store.state.menuflag;
                this.$store.state.hideNavBar = false;
            },
            onScroll(e){
                if(pageYOffset>=document.getElementById("voicepartbg").offsetTop-window.innerHeight || document.getElementById("firstpartbg").getBoundingClientRect().top>0) this.menubuttonscroll_flag=false;
                else this.menubuttonscroll_flag=true;
                
                this.offsetfory = e.target.documentElement.scrollTop
            },
        }
    };
</script>

<style lang="scss" scoped>
    .menubutton{
        position: fixed;
        z-index: 5003;
        left: -300px;
        top: 74px;
        cursor: pointer;
        transition: left .5s;
        @media (min-width: 414px) AND (max-width: 768px) {
            top: 80.21px;
        }
        @media (min-width: 768px) {
            top: 110.21px;
        }
    }
    .menubuttonscroll{
        left: -12px;
    }
    @media (hover: hover) {
        .menubutton:hover{
            @media (min-width: 960px) {
                left: 0;
                .pctext{
                    content: url('https://p3.udn.com.tw/wish/images/common/button_people_menu_pc_golden.svg');
                }
            }
        }
    }
</style>